type ProcessingActivityDraftFlags = {
  hasDraft: boolean;
  status?: string | null;
};

export const isProcessingActivityDraftInProgress = ({ hasDraft, status }: ProcessingActivityDraftFlags): boolean => hasDraft || !status;

export default isProcessingActivityDraftInProgress;
